import React from "react";
import { arrayOf, shape, string } from "prop-types";
import {
	ShareDownloadsButtonsContainer,
	ShareDownloadsButtonsRow,
	ShareDownloadsParagraph,
} from "@insightfulscience/atomic-react/r1/molecules/ShareDownloads";
import { useLocale } from "@insightfulscience/i18";
import ShareDownloadLinkItem from "./ShareDownloadsLinkItem";
import { useDownloadsContext } from "../DownloadsContextProvider";

const renderDownloadLink = download => download != null && <ShareDownloadLinkItem {...download} />;

const ShareDownloadLinks = ({ items, productVersion }) => {
	const [t] = useLocale("share-downloads-links");
	const downloads = React.useMemo(
		() => new Map(items.map(item => [item.os, item])),
		[items], //
	);

	const {
		isRpmLinksEnabled,
		isWindowsLinksEnabled,
		isUbuntuLinksEnabled,
		isMacLinksEnabled,
	} = useDownloadsContext();

	return (
		<>
			<ShareDownloadsParagraph className="mb-10">
				{t("TITLE", {
					version: productVersion,
				})}
			</ShareDownloadsParagraph>
			<ShareDownloadsButtonsContainer>
				<ShareDownloadsButtonsRow>
					{isMacLinksEnabled && renderDownloadLink(downloads.get("mac"))}
					{isWindowsLinksEnabled && renderDownloadLink(downloads.get("windows"))}
				</ShareDownloadsButtonsRow>
				<ShareDownloadsButtonsRow>
					{isUbuntuLinksEnabled && renderDownloadLink(downloads.get("linux_deb"))}
					{isRpmLinksEnabled && renderDownloadLink(downloads.get("linux_rpm"))}
				</ShareDownloadsButtonsRow>
			</ShareDownloadsButtonsContainer>
		</>
	);
};

ShareDownloadLinks.propTypes = {
	items: arrayOf(
		shape({
			os: string,
			id: string,
			minOSVersion: string,
			minOSName: string,
			downloadLink: string,
		}),
	).isRequired,
	productVersion: string.isRequired,
};

export default ShareDownloadLinks;
